import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Modal,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { viewPDF } from "../../utils/viewPDF";
import ErrorModal from "../../utils/ErrorModal";
import { handleExportPDF } from "../../utils/exportToPDF";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ViewDepositGiven = () => {
  const [sra, setSra] = useState();
  const { sraId } = useParams();
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [fileNames, setFileNames] = useState({
    attachment1Filename: "",
    attachment2Filename: "",
    attachment3Filename: "",
  });
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [open, setOpen] = useState();
  const [openError, setOpenError] = useState();
  const [errorMsg, setErrorMsg] = useState();
  const [status, setStatus] = useState();
  const [errors, setErrors] = useState({});
  const [reason, setReason] = useState();
  const [history, setHistory] = useState();
  const [exporting, setExporting] = useState(false);
  const pdfRef = useRef();

  const handleOpen = (s) => {
    setOpen(true);
    setStatus(s);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenError(false);
    setErrorMsg();
    setStatus("");
    setReason("");
  };

  useEffect(() => {
    const getSRA = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/deposit-given/by-id?sraId=${sraId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setSra(res.data);
        setFileNames({
          ...fileNames,
          attachment1Filename: res.data.attachment1Filename || "",
          attachment2Filename: res.data.attachment2Filename || "",
          attachment3Filename: res.data.attachment3Filename || "",
        });
        setHistory(res.data.histories);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    getSRA();
  }, []);

  const validateForm = () => {
    const newErrors = {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(reason)) {
      newErrors.reason = "Reason is required";
    } else if (reason?.toString().length > 1000) {
      newErrors.reason = "Only 1000 characters are allowed.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/deposit-given/update-sra`,
        {
          sraId: sraId,
          username: storedUser.username,
          status: status,
          reason: reason,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      navigate("/dashboard");
    } catch (error) {
      console.log(error);
      setOpenError(true);
      setErrorMsg(error.response?.data?.Exception || "Failed to update form.");
    } finally {
      setBtnLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");

    const [hours, minutes] = time?.split(".")[0].split(":") || [];

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      {exporting && (
        <div className="uploading-div">
          Exporting PDF, this may take a while.{" "}
          <CircularProgress color="#fff" />
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button
          className="btn-contained"
          sx={{ width: "200px" }}
          onClick={async () => {
            try {
              setExporting(true);
              await handleExportPDF("deposit-given", `${sraId.includes("WBDG")  ? "Write_Back" : "Write_Off"}_Deposit_Given`, sraId);
            } catch (error) {
              console.log(error);
            } finally {
              setExporting(false);
            }
          }}
        >
          Export PDF
        </Button>
      </div>
      <div ref={pdfRef}>
        <Box className="dashboard-container" px={10}>
          <h2>{`${sraId.includes("WBDG")  ? "Write Back" : "Write Off"} Deposit Given`}</h2>
          <Typography className="form-title">Details</Typography>
          {loading ? (
            <Box>Loading...</Box>
          ) : (
            <Grid2 container>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderTop: "1px solid #000" }}
              >
                Document ID
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{
                  borderTop: "1px solid #000",
                  borderRight: "1px solid #000",
                }}
              >
                {sra?.depositId || "N/A"}
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
              >
                Title
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{
                  borderRight: "1px solid #000",
                }}
              >
                {sra?.title || "N/A"}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                SAP Document Number
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{
                  borderRight: "1px solid #000",
                }}
              >
                {sra?.sapNumber || "N/A"}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                Vendor Code
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{
                  borderRight: "1px solid #000",
                }}
              >
                {sra?.code || "N/A"}
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                Vendor Name
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderRight: "1px solid #000" }}
              >
                {sra?.name || "N/A"}
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                Total Amount
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderRight: "1px solid #000" }}
              >
                {sra?.amount || "N/A"}
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                Vendor Details
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderRight: "1px solid #000" }}
              >
                {sra?.details || "N/A"}
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                Reason For Write Off/Back
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderRight: "1px solid #000" }}
              >
                {sra?.reason || "N/A"}
              </Grid2>

              {[1, 2, 3].map((num) => (
                <React.Fragment key={num}>
                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Attachment {num}
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {sra?.[`attachment${num}`] ? (
                      <Button
                        sx={{
                          margin: "0 !important",
                          padding: "0 !important",
                          width: "max-content !important",
                          fontSize: "12px !important",
                          textDecoration: "underline",
                          textAlign: "start",
                        }}
                        onClick={() =>
                          viewPDF(sra?.[`attachment${num}`], storedUser)
                        }
                      >
                        <Box
                          component="span"
                          sx={{
                            display: "inline-block",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }}
                        >
                          {fileNames?.[`attachment${num}Filename`]}
                        </Box>
                      </Button>
                    ) : (
                      "N/A"
                    )}
                  </Grid2>
                </React.Fragment>
              ))}
            </Grid2>
          )}
        </Box>

        <Box className="dashboard-container" px={10}>
          <Typography variant="h6">Approvers</Typography>
          {loading ? (
            <Box>Loading...</Box>
          ) : (
            <Grid2 container>
              {sra &&
                sra?.approvers
                  ?.sort((a, b) => a.number - b.number)
                  .map((approver, index) => (
                    <React.Fragment key={index}>
                      <Grid2
                        size={{ xs: 12, sm: 6 }}
                        className="preview-grid"
                        sx={index === 0 ? { borderTop: "1px solid #000" } : {}}
                      >
                        APPROVER {index + 1}
                      </Grid2>
                      <Grid2
                        size={{ xs: 12, sm: 6 }}
                        className="preview-grid"
                        sx={{
                          borderRight: "1px solid #000",
                          ...(index === 0 && { borderTop: "1px solid #000" }),
                        }}
                      >
                        {approver?.approver?.name || "N/A"} (
                        {approver?.approver?.userRoleName.replace("_", " ") ||
                          "N/A"}
                        )
                      </Grid2>
                    </React.Fragment>
                  ))}
            </Grid2>
          )}
        </Box>
        {history && history.length > 0 && (
          <Box className="dashboard-container" px={10}>
            <Typography variant="h6">Approval History</Typography>
            {loading ? (
              <Box>Loading...</Box>
            ) : (
              <table
                border={1}
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  marginTop: "10px",
                }}
              >
                <thead>
                  <tr style={{ fontWeight: "bold" }}>
                    <th style={{ padding: "20px" }}>Name</th>
                    <th>Date</th>
                    <th>Comment</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loading
                    ? "Loading..."
                    : sra &&
                      history &&
                      history
                        ?.sort(
                          (a, b) =>
                            new Date(a.createdDate) - new Date(b.createdDate)
                        )
                        ?.map((history, index) => (
                          <tr key={index} style={{ textAlign: "center" }}>
                            <td style={{ padding: "20px" }}>
                              {history.orgUser.name} (
                              {history.orgUser.userRoleName.replace("_", " ")})
                            </td>
                            <td>{formatDate(history.createdDate)}</td>
                            <td>{history.comment}</td>
                            <td>{history.status || "-"}</td>
                          </tr>
                        ))}
                </tbody>
              </table>
            )}
          </Box>
        )}
      </div>
      <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
        <Button className="btn-outlined" onClick={() => navigate("/dashboard")}>
          Back
        </Button>
        {storedUser.userRole[0] !== "BUYER" &&
          sra?.status === "PENDING" &&
          sra?.approvers?.some(
            (a) =>
              a.number === sra.stage &&
              a.approver?.email === storedUser.username
          ) && (
            <>
              <Button
                className="btn-outlined"
                onClick={() => handleOpen("QUERY")}
              >
                Send for Query
              </Button>
              <Button
                className="btn-outlined btn-reject"
                onClick={() => handleOpen("REJECTED")}
              >
                Reject
              </Button>
              <Button
                className="btn-contained"
                onClick={() => handleOpen("APPROVED")}
              >
                Approve
              </Button>
            </>
          )}
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {status === "APPROVED"
              ? `Approve the ${sraId.includes("WBDG") ? "Write Back" : "Write Off"} Deposit Given`
              : status === "QUERY"
              ? "Send Approval Request for Query"
              : `Reject the ${sraId.includes("WBDG") ? "Write Back" : "Write Off"} Deposit Given`}
          </Typography>
          <label htmlFor="reason">
            Please give reason for{" "}
            {status === "APPROVED"
              ? "Approv"
              : status === "QUERY"
              ? "Quer"
              : "Reject"}
            ing the approval request*
          </label>
          <textarea
            className={`${errors.reason && "input-error"}`}
            name="reason"
            id="reason"
            onChange={(e) => {
              setReason(e.target.value);
              setErrors({ reason: "" });
            }}
            rows={8}
            maxLength={200}
          ></textarea>
          {errors.reason && <p className="error">{errors.reason}</p>}
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button className="btn-outlined" onClick={handleClose}>
              Close
            </Button>
            <Button
              className="btn-contained"
              onClick={handleUpdate}
              disabled={btnLoading}
            >
              {btnLoading ? "Submitting" : "Submit"}
            </Button>
          </Box>
        </Box>
      </Modal>

      <ErrorModal
        open={openError}
        handleClose={() => setOpenError(false)}
        msg={errorMsg}
      />
    </div>
  );
};

export default ViewDepositGiven;
